// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const token = authServices.getToken();

  const [data, setData] = useState([]);
  const fetchCommodities = async () => {
    try {
      const response = await apiClient.get(`/api/admin/commodity/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.commodity, item])).values()
  );

  const validData = filteredData.filter((item) => item.commodity);
  
const [LableData, setLableData] = useState({
    commodity: null,
  });

  const [formData, setFormData] = useState({

    id: null,
    subCommodity: '',
    commodity: null,

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //*********************************** Fetch invoice data when the modal opens ********************************************************

  const fetchInvoiceData = async () => {
    if (edit && invoiceId) {
      loader('enable');

      try {
        const response = await apiClient.get(`/api/admin/sub_commodity/${invoiceId}`, {

          headers: {
            'access_token': token,
          },

        });

        if (response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || null,
            subCommodity: response.data.data.subCommodity || '',
            commodity: response.data.data.commodity.id || null,
          });
          setLableData({
            commodity: response.data.data.commodity.commodity || null,
          });
        }
        else {
          console.log(response.data.message)
        }
      } catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      } finally {
        loader('disable');
      }
    }
  };

  //******************************************* Handle save and update the data **************************************************
 
  const AllData = {
    id: formData.id,
    subCommodity:formData.subCommodity,
    commodity: {
      id: formData.commodity
    },
  }

 
  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/sub_commodity/update`, AllData, {

        headers: {
          'access_token': token,
        },
      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };

  useEffect(() => {
    fetchCommodities()
    fetchInvoiceData();
  }, [invoiceId, edit]);


  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Sub_Commodity
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className="spacing">
                    <label htmlFor="commodity" className="label-custom">Commodity</label>
                    <Autocomplete
                      // className={` ${errors.commodity ? 'input-error' : ''}`}
                      disablePortal
                      options={validData} // Full user object
                      getOptionLabel={(option) => option.commodity} // Show 'name' in dropdown
                      getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                      renderInput={(params) => <TextField {...params} label={LableData.commodity} />} 
                      onChange={(event, value) => {
                        if (value) {
                          setFormData({ ...formData, commodity: value.id }); // Save 'id' in state
                        } else {
                          setFormData({ ...formData, commodity: "" }); // Reset state 
                        }
                      }}
                      // Key attribute setup using 'id'
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          {option.commodity}
                        </li>
                      )}
                      componentsProps={{
                        paper: {
                          style: {
                            maxHeight: '120px', // Dropdown ki maximum height
                            overflowY: 'auto',  // Scroll enable karega
                          },
                        },
                      }}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="subCommodity" className="label-custom">Sub Commodity</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="subCommodity"
                      name="subCommodity"
                      value={formData.subCommodity}
                      onChange={handleChange}
                    />
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
